/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicDailyInventoryReport extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicDailyInventoryReport");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicDailyInventoryReport.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicDailyInventoryReport>): BackgroundJobPayloadForPeriodicDailyInventoryReport {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicDailyInventoryReport(), model);
        BackgroundJobPayloadForPeriodicDailyInventoryReport.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicDailyInventoryReport>): BackgroundJobPayloadForPeriodicDailyInventoryReport {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicDailyInventoryReport.newInstance(<BackgroundJobPayloadForPeriodicDailyInventoryReport> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicDailyInventoryReport) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicDailyInventoryReport.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicDailyInventoryReport): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicDailyInventoryReport.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
